jQuery.fn.slideSelectorMenu = function() {
  let self = this
  self.selector = $('<div class="slide-selector-menu__selector"></div>')
  self.selector_line = $('<div class="slide-selector-menu__selector-line"></div>')

  self.selected = function() {
    self.selector.css('left', ($(this).offset().left - self.offset().left + self.get(0).scrollLeft) + 'px')
    self.selector.css('width', $(this).width() + 'px')
    difference = $(this).offset().left - self.find('button:first-child').offset().left;
    self.animate({scrollLeft: difference}, 300);
  }

  function checkOverflow() {
    var inner_width = 0
    self.find('button').each(function() {
      inner_width += $(this).outerWidth()
      inner_width += parseInt($(this).css('margin-left'))
    });
    self.css('--inner-width', inner_width + 'px')
    outer_width = self.innerWidth() - parseInt(self.css('padding-right')) - parseInt(self.css('padding-left'));
    if (inner_width > outer_width) {
      self.addClass('overflow');
    } else {
      self.removeClass('overflow');
    }
  }

  return function() {
    /* build */
    self.addClass("slide-selector-menu");
    self.append(self.selector);
    self.append(self.selector_line);

    /* add event listeners */
    $(window).on('resize orientationchange load', function() {
      self.find('button[aria-selected=true]').click()
      checkOverflow()
    })
    self.find('> button').on('click', self.selected)
    checkOverflow();
    return self
  }()
};
